import { ACTION_TYPES } from 'app-constants/actionTypes';
import { isNotEmpty } from 'utils';
import slugify from '../utils';
import replacer from './variablesUtils';

// eslint-disable-next-line no-unused-vars
export const processRulesTransitions = (nodeId, node, nodes) => {
  const { data } = node;
  const { properties, title } = data;
  const { type, conditions } = properties;

  if (type === ACTION_TYPES.CONDITIONAL_STEP && isNotEmpty(conditions)) {
    const transitionKeys = Object.values(conditions).reduce((accum, condition, index) => {
      const { name: conditionName } = condition;
      const { connections: conditionConnections } = node.outputs[slugify(conditionName)];
      const nextTransition = conditionConnections.length > 0 ? conditionConnections[0].node : '';

      return {
        ...accum,
        [`c${index + 1}`]: nextTransition ? slugify(`${nodes[nextTransition].data.title}${nextTransition}`) : '',
      };
    }, {});

    const { connections: conditionConnections } = node.outputs[slugify('default')];
    const defaultConnection = conditionConnections.length > 0 ? conditionConnections[0].node : '';

    return {
      [slugify(`${title}${nodeId}`)]: {
        next: {
          ...transitionKeys,
          default: defaultConnection ? slugify(`${nodes[defaultConnection].data.title}${defaultConnection}`) : '',
        },
        action: slugify(`${title}${nodeId}_action`),
      },
    };
  }

  return {};
};

export const createRulesFunction = (nodes, variables) => Object.keys(nodes).reduce(
  (accum, nodeId) => {
    const { data } = nodes[nodeId];
    const { properties, title } = data;
    const { type, conditions } = properties;

    if (type === ACTION_TYPES.CONDITIONAL_STEP && isNotEmpty(conditions)) {
      const code = Object.values(conditions).reduce((conditionAccum, condition, index) => {
        const { logic } = condition.jsonLogic;

        return [
          ...conditionAccum,
          {
            label: condition.name,
            rule: logic,
            output: `c${index + 1}`,
          },

        ];
      }, []);

      const input = Object.values(conditions).reduce((conditionAccum, condition) => {
        const { data: jsonLogicData } = condition.jsonLogic;
        return {
          ...conditionAccum,
          ...Object.keys(jsonLogicData).reduce((inputAccum, variable) => {
            const variableName = /^user_[^\s]+/.test(variable)
              ? variable.split('_').pop() : variable;
            return {
              ...inputAccum,
              [variable]: variables[variableName].type,
            };
          }, {}),
        };
      }, {});

      const outputValues = Object.values(conditions).reduce((conditionAccum, _, index) => ([
        ...conditionAccum,
        `c${index + 1}`,
      ]), ['default']);

      return {
        ...accum,
        [`conditional_step_function${slugify(title + nodeId)}`]: {
          runtime: 'jsonlogic',
          version: '',
          code: {
            conditions: code,
          },
          input,
          output: {
            type: 'string',
            values: outputValues,
            sample: 'c1',
          },
        },
      };
    }

    return accum;
  }, {},
);

export const createRulesActions = (type, nodeProperties, nodeId, title, variables) => {
  const { conditions } = nodeProperties;

  if (type === ACTION_TYPES.CONDITIONAL_STEP && isNotEmpty(conditions)) {
    return {
      [slugify(`${title}${nodeId}_action`)]: {
        type: 'conditional_step',
        vars: {},
        eval: {
          function: `session.conditional_step_function${slugify(title + nodeId)}`,
          input: Object.values(conditions).reduce((accum, condition) => {
            const { data } = condition.jsonLogic;
            return {
              ...accum,
              ...Object.keys(data).reduce((inputAccum, variable) => ({
                ...inputAccum,
                [variable]: replacer(`{\u00A0${[variable]}\u00A0}`, variables),
              }), {}),
            };
          }, {}),
        },
        on_error: {
          next: '',
        },
      },
    };
  }

  return {};
};
